import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import useAuth from '../../auth/useAuth';

import Layout from '../UI/introGameLayout/layout';
import QuestionsTransactionsTable from '../UI/questionsTransactionsTable';

import {
  generalInfoSummaryQuery,
  consolidatedInsightsQuery,
} from './api';

import {
  popupMessagesSummaryDecisionBreakdown,
  summaryDecisionBreakdownElementsHeaders
} from './data';

import PopupMessages from '../UI/introGameLayout/popupMessages';

import './styles.css';

export default function ThePrinciplesSummaryDecisionBreakdown() {
  const navigate = useNavigate();

  const {
    getUser,
    getCurrentThePrinciplesGameId
  } = useAuth();

  const user = getUser();

  const gameId = getCurrentThePrinciplesGameId();

  const [isFirstGameOfTheType, setIsFirstGameOfTheType] = useState(false);

  const [elementsTableData, setElementsTableData] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);

  const { data: generalInfo } = useQuery(generalInfoSummaryQuery()) || {};
  const { data: consolidatedInsights } = useQuery({
    ...consolidatedInsightsQuery({ userId: user?.id }),
    enabled: !!user?.id,
  });

  const games = generalInfo?.games;
  const gamesSessions = generalInfo?.sessions;

  useEffect(() => {
    if(gamesSessions && games && gameId && user) {
      if(gamesSessions.filter(
          session =>
            games.find(game => game.id === session.game && game.game_type === 'The Principles')
        ).length < 2) {
        setIsFirstGameOfTheType(true);
      }
    }
  }, [gamesSessions, games, gameId, user]);

  useEffect(() => {
    if (consolidatedInsights) {
      const principlesInsights = consolidatedInsights.principles || [];
      const header = 'Impact on Profits';

      const elementsData = [];

      principlesInsights.forEach(insight => {
        const row = {
          question: insight.question,
        };

        (insight.options || []).forEach(option => {
          const isCorrect = option.is_correct;

          if (row[header]) {
            row[header].push({
              value: option.option,
              isCorrect,
              background: isCorrect ? '#D1E9D6' : '#FBD8D8',
            });
          } else {
            row[header] = [{
              value: option.option,
              isCorrect,
              background: isCorrect ? '#D1E9D6' : '#FBD8D8',
            }];
          }
        });

        elementsData.push(row);
      });

      setElementsTableData(elementsData);
      setDataLoaded(true);
    }
  }, [consolidatedInsights]);

  const handlePopupMessagesNextButtonClick = () => {
    let redirectPath = '/the-principles/summary/final';
    if(isFirstGameOfTheType) {
      redirectPath = '/the-principles/summary/feedback';
    }
    navigate(redirectPath);
  }

  const handlePopupMessagesPrevButtonClick = () => {
    navigate('/the-principles/summary/breakdown');
  }

  return(
    <Layout
      backgroundColor="#FBEDD5"
      isBackgroundBlurred={false}
      isHeaderVisible={true}
      isFooterVisible={false}
    >
      {
        dataLoaded &&
          <div className="game-summary-container game-summary-decision-questions-transactions-container">
            <PopupMessages
              messages={popupMessagesSummaryDecisionBreakdown}
              messageSize="xx-small"
              buttonText="Next"
              onButtonClick={handlePopupMessagesNextButtonClick}
              additionalButtonText="Back"
              onAdditionalButtonClick={handlePopupMessagesPrevButtonClick}
              isAvatarOnTop={true}
            />
            <QuestionsTransactionsTable
              tableColumnHeader="Transactions"
              tableHeaders={summaryDecisionBreakdownElementsHeaders}
              tableData={elementsTableData}
              bigCells={true}
            />
          </div>
      }
    </Layout>
  );
}
